import { DateOccurrenceType } from './date-occurrence-type.model';
import { OccurenceStatus } from './occurence-status.model';

export class Occurence {
    id: number;
    creationDateTime: Date;
    companyName: string;
    userName: string;
    fundName: string;
    fundCnpjCpf: string;
    fundCode: string;
    fundNumber?: number;
    description: string;
    occurrenceStatus: OccurenceStatus;
    dateOccurrenceTypes: Array<DateOccurrenceType>;
    hasComments?: number;
    occurrenceComments?: Array<any>;

    constructor(
        id: number,
        creationDateTime: Date,
        companyName: string,
        userName: string,
        fundName: string,
        fundCnpjCpf: string,
        fundCode: string,
        description: string,
        occurrenceStatus: OccurenceStatus,
        dateOccurrenceTypes: DateOccurrenceType[],
        occurrenceComments?: any[],
        fundNumber?: number
         ) {
        this.id = id;
        this.creationDateTime = creationDateTime;
        this.companyName = companyName;
        this.description = description;
        this.userName = userName;
        this.fundName = fundName;
        this.fundCnpjCpf = fundCnpjCpf;
        this.fundCode = fundCode;
        this.occurrenceStatus = occurrenceStatus;
        this.dateOccurrenceTypes = dateOccurrenceTypes;
        this.occurrenceComments = occurrenceComments;
        this.fundNumber = fundNumber;
    }
}
